import React, { FunctionComponent, useEffect, useState } from 'react'

import { ConfirmationModal } from '../confirmationModal/ConfirmationModal'

export type ProviderCalendarBaseSlotSelectionModalProps = {
  cancelButtonText?: string
  confirmButtonDisabled?: boolean
  confirmationButtonText?: string
  handleAnimationEnd?: () => void
  modalTitle?: string
  onConfirmationButtonPress: () => void
  onRequestClose: () => void
  testID?: string
  visible: boolean
  modalContents: React.ReactNode
}

export const ProviderCalendarBaseSlotSelectionModal: FunctionComponent<ProviderCalendarBaseSlotSelectionModalProps> = ({
  cancelButtonText = 'Cancel',
  confirmButtonDisabled = false,
  confirmationButtonText = 'Add',
  handleAnimationEnd = () => {},
  modalTitle = 'Add availability',
  onConfirmationButtonPress,
  onRequestClose,
  testID = 'ProviderCalendarBaseSlotSelectionModal',
  visible,
  modalContents,
}) => {
  const [isConfirmButtonLoading, setIsConfirmButtonLoading] = useState(false)

  useEffect(() => {
    if (visible) setIsConfirmButtonLoading(false)
  }, [visible])

  return (
    <ConfirmationModal
      visible={visible}
      onRequestClose={onRequestClose}
      handleAnimationEnd={handleAnimationEnd}
      onConfirmationButtonPress={() => {
        setIsConfirmButtonLoading(true)
        onConfirmationButtonPress()
      }}
      modalTitle={modalTitle}
      cancelButtonText={cancelButtonText}
      confirmationButtonText={confirmationButtonText}
      confirmButtonDisabled={confirmButtonDisabled || isConfirmButtonLoading}
      confirmButtonLoading={isConfirmButtonLoading}
      testID={testID}
      modalContents={modalContents}
    />
  )
}
